import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import Translate from "../../utils/Translate";
import { getOrderIconbox } from "../../utils/order";
import { formatMoney } from "../../utils/formatMoney";

export default function OrdersGridDetailsPanel({ orderLines, currency }) {
  return (
    <Grid container direction="column" size={12}>
      {orderLines.map((ol) => (
        <Grid
 container
 key={ol.orderLineId}
 direction="row"
 justifyContent="center"
 alignItems="center"
 paddingTop="4px"
 paddingBottom="4px" size={12}>
          <Grid size={2}>
            {ol.part.partNo}
          </Grid>
          <Grid overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" size={4}>
            {ol.part.description.trim()}
          </Grid>
          <Grid size={2}>
            {ol.qty}
          </Grid>
          <Grid size={1.8}>
            {formatMoney(ol.price, null, currency)}
          </Grid>
          <Grid textAlign="right" size={0.4}>
            <Stack direction="row" alignItems="center">
              {getOrderIconbox(ol.status, null, "gray", true)}
            </Stack>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
